import { useState, useEffect, useRef } from 'react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import { ValidateInput } from '../../utilities';
import "./style.css";

function CustomizedDatePicker(props) {
    const {
        label,
        name,
        required,
        value,
        error,
        schema
    } = props

    const datePickerContainerRef = useRef()
    const textInputContainerRef = useRef()
    const datePickerRef = useRef()
    const textInputRef = useRef()

    const [showDatePicker, setShowDatePicker] = useState(false)
    const [currentValue, setCurrentValue] = useState()
    const [isValid, setIsValid] = useState(!error)

    const validateInput = (captureValue) => {
        const valid = ValidateInput(schema, { [name]: captureValue })
        setIsValid(valid)
    }

    const toggleDatePicker = (visible) => {
        if(visible){
            datePickerRef.current.style.visibility = "visible"
            datePickerRef.current.style.height = "auto"
            datePickerRef.current.style.width = "100%"
            datePickerRef.current.classList.add("form-control")
            datePickerContainerRef.current.classList.add("w-100")
            datePickerContainerRef.current.style.visibility = "visible"
            setShowDatePicker(true)
        }
        else {
            datePickerRef.current.style.visibility = "hidden"
            datePickerRef.current.style.height = 0
            datePickerRef.current.style.width = 0
            datePickerRef.current.classList.remove("form-control")
            datePickerContainerRef.current.classList.remove("w-100")
            datePickerContainerRef.current.style.visibility = "hidden"
            setShowDatePicker(false)
        }
    }

    const toggleTextInput = (visible) => {
        if(visible){
            textInputRef.current.style.visibility ="visible"
            textInputRef.current.style.height = "auto"
            textInputRef.current.style.width = "100%"
            textInputContainerRef.current.classList.add("w-100")
            textInputRef.current.classList.add("form-control")
            textInputContainerRef.current.style.visibility = "visible"
        }
        else {
            textInputRef.current.style.visibility ="hidden"
            textInputRef.current.style.height = 0
            textInputRef.current.style.width = 0
            textInputContainerRef.current.classList.remove("w-100")
            textInputRef.current.classList.remove("form-control")
            textInputContainerRef.current.style.visibility = "hidden"
        }
    }

    const mydate = () => {
        toggleDatePicker(true)
        toggleTextInput(false)

        datePickerRef.current.showPicker();
        validateInput(datePickerRef.current.value)
    }

    const mydate1 = () => {
        let d = new Date()
        if(datePickerRef.current.value.length > 0){
            d = new Date(datePickerRef.current.value);
        }
        const tempDt = d.getDate()
        const dt = tempDt.toString().length === 1 ? `0${tempDt}` : tempDt
        const tempMn = d.getMonth() + 1
        const mn = tempMn.toString().length === 1 ? `0${tempMn}` : tempMn
        const yy = d.getFullYear()
        textInputRef.current.value = dt + "/" + mn + "/" + yy

        toggleDatePicker(false)
        toggleTextInput(true)

        setCurrentValue(dt + "/" + mn + "/" + yy)
        validateInput(dt + "/" + mn + "/" + yy)
    }

    useEffect(() => {
        toggleDatePicker(false)
        toggleTextInput(true)

        if (value) {
            setCurrentValue(value)
        }
        else {
            const year = new Date().getFullYear()
            const month = new Date().getMonth() + 1
            const date = new Date().getDate()
            setCurrentValue(`${date.toString().length === 1 ? '0' + date : date}/${month.toString().length === 1 ? '0' + month : month}/${year}`)
        }
    }, [])

    useEffect(() => {
        setIsValid(!error)
    }, [error])

    return <div className={`form-group form-element ${!isValid ? "error" : ""}`} id={name}>
        <label htmlFor={name}>{label} {required ? <span className='text-danger'>*</span> : null}</label>
        <div className='w-100 d-flex justify-content-start align-items-center'>
            <div ref={datePickerContainerRef} className='w-100 d-flex justify-content-start align-items-center'>
                <input ref={datePickerRef} className="form-control" type="date" id="dt" onChange={mydate1} defaultValue={currentValue} style={{ visibility: "hidden" }} />
                {showDatePicker ? <CalendarMonthIcon onClick={mydate} /> : null}
            </div>
            <div ref={textInputContainerRef} className='w-100 d-flex justify-content-start align-items-center'>
                <input ref={textInputRef} className="form-control" type="text" id="ndt" name={name} onClick={mydate} defaultValue={currentValue} style={{ visibility: "visible" }} />
                {!showDatePicker ? <CalendarMonthIcon onClick={mydate} /> : null}
            </div>
        </div>
    </div>
}

export default CustomizedDatePicker;